// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import { EditableComponent } from '@adobe/aem-react-editable-components';
import dynamic from 'next/dynamic';

export const ActivateOrForgotForm = dynamic(() =>
  import('./ActivateOrForgotForm').then(mod => mod.ActivateOrForgotForm)
);
export const ActivateOrForgotFormConfig = {
  emptyLabel: 'ActivateOrForgotForm',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/activateorforgotform`,
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ActivateOrForgotFormEditable = (props: any) => {
  return props.cqPath?.includes('datapagecomponent') ? (
    <ActivateOrForgotForm {...props} />
  ) : (
    <EditableComponent config={ActivateOrForgotFormConfig} {...props}>
      <ActivateOrForgotForm {...props} />
    </EditableComponent>
  );
};
